import { Stack } from '@mui/material'
import Header from '../components/Header/Header'
import FluxoTabs from '../components/Fluxo/FluxoTabs';

export default function CadastroModeloPage() {

  return (
    <>
      <Header />
      <Stack direction='column' padding={'100px'} alignItems='flex-start' justifyContent='flex-start' spacing={3} position='relative'>
       <FluxoTabs />
      </Stack>
    </>
  )
}
